import { Modal, Row, Col, Button } from 'react-bootstrap';
import React, { useEffect } from 'react';
import CardNavigationTab from '~/Components/CardNavigationTab';
import { useState } from 'react';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import { FaWindowClose } from 'react-icons/fa';
import AuthStorage from '~/Utils/AuthStorage';
import * as constants from '~/constant';
import DetalhesAtivo from '../AdmVendas/DetalhesAtivo';
import ModalComissao from './ModalComissao';

const ModalDetalhesComissao = ({
  mostrarModal,
  setMostrarModal,
  linhaSelecionada,
}) => {
  const [tab, setTab] = useState('comissao');
  const [ativo, setAtivo] = useState(null);

  useEffect(() => {
    const buscarAtivoDetalhes = async () => {
      if (!linhaSelecionada.pre_venda) return;
      try {
        const response = await api.detalharPreVenda(linhaSelecionada.pre_venda);
        if (response) {
          setAtivo(response);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    buscarAtivoDetalhes();
  }, []);

  const verificaTab = tab => {
    setTab(tab);
  };

  return (
    <Modal
      show={mostrarModal}
      onHide={() => setMostrarModal(false)}
      size={'xl'}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Detalhes Comissão - Pré-venda {linhaSelecionada.pre_venda}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <Row>
          <Col className="">
            <CardNavigationTab
              activeTab={tab}
              onChangeTab={verificaTab}
              tabs={[
                {
                  label: 'Comissão',
                  url: 'comissao',
                  component: <ModalComissao linhaSelecionada={linhaSelecionada} />,
                },
                {
                  label: 'Histórico',
                  url: 'historico',
                  component: <div />,
                },
                {
                  label: 'Detalhes da venda',
                  url: 'detalhes-pre-venda',
                  component: (
                    <DetalhesAtivo
                      linhaSelecionada={linhaSelecionada}
                      ativo={ativo}
                    />
                  ),
                },
              ].filter(Boolean)}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <>
          <Button
            variant={'light'}
            type="submit"
            className="d-inline-flex align-items-center"
            onClick={() => {
              setMostrarModal(false);
            }}
          >
            <FaWindowClose />
            <span className="ml-2 d-xs-none">Fechar</span>
          </Button>
        </>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetalhesComissao;
